import { useEffect, useState } from 'react';
import { useCompleteSignIn } from '../../hooks/authhooks';
import BusinessTabs from '../../molecules/Desktop/BusinessTabs';
import { BusinessStageType, BusinessTabType, FocusGroupSessionSchema, AccountSchema, FocusGroupSessionResponseSchema } from '../../data/types';
import { useSearchParams, useParams, useNavigate } from 'react-router-dom';
import LiveSessionIndicator from '../../molecules/Desktop/LiveSessionIndicator';
import SessionMap from '../../molecules/Desktop/SessionMap';
import { ArrowBack, ArrowForward } from '@mui/icons-material';
// import { sessions } from '../../data/focus_groups_sessions';
// import { MOCK_FOCUS_GROUPS } from '../../data/focus_groups_sessions';
import { useFocusGroupSession, useFocusGroupFormattedSessions } from '../../hooks/businesshooks';
import moment from 'moment-timezone';
// import NewLoadingUI from '../../components/NewLoadingUI';
import FocusGroupSessionSkeleton from '../../components/FocusGroupSessionSkeleton';
import { capitalizeString, capitalizeWords, formatDuration } from '../../utils/helpers';
import { toast } from 'sonner';

type QuestionType = 'checkbox' | 'rating' | 'open';

interface Question {
  id: string;
  type: QuestionType;
  title: string;
  text: string;
  options?: string[];
  maxSelections?: number;
}



const FocusGroupSession = () => {
  const { sessionId } = useParams();
  const { user } = useCompleteSignIn();
  const isLoggedIn = !!user?.username && !!user?.uid;
  // const navigate = useNavigate();

  const startTab = {
    dream: 'focus-group', 
    build: 'focus-group', 
    scale: 'focus-group'
} as BusinessTabType


const [searchParams] = useSearchParams();
const stage = searchParams.get('stage');
const [businessStage, setBusinessStage] = useState<BusinessStageType>(stage as BusinessStageType || 'dream');

  return (
    <div className="flex flex-col min-h-screen bg-white">
    {isLoggedIn && <BusinessTabs startTab={startTab} businessStage={businessStage} setBusinessStage={setBusinessStage} />}
    <div className={`flex flex-col ${isLoggedIn ? '' : 'mt-[60px]'}`}>
      <FocusGroupSessionForms user={user as AccountSchema} sessionId={sessionId as string} />
    </div>
      
    </div>
  );
}



type FocusGroupSessionFormsProps = {
  user: AccountSchema
  sessionId: string
}


export const FocusGroupSessionForms: React.FC<FocusGroupSessionFormsProps> = ({ user, sessionId }) => {
  const [currentSession, setCurrentSession] = useState(0);
  const [currentSection, setCurrentSection] = useState(0);
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [responses, setResponses] = useState<Record<string, any>>({});
  const [sessionStartTime] = useState(moment());
  const [otherTexts, setOtherTexts] = useState<{[key: string]: string | string[]}>({});
  const [elapsedTime, setElapsedTime] = useState<string>('00:00:00');
  const navigate = useNavigate();

  // console.log('current responses', responses)

  // const liveSessions = MOCK_FOCUS_GROUPS.filter(session => session.id === sessionId) as FocusGroupSessionSchema[];
  // const communityId = ""
  const { formattedFocusGroupSessions } = useFocusGroupFormattedSessions()
  const session = formattedFocusGroupSessions.find(session => session.id === sessionId) as FocusGroupSessionSchema;
  const liveSessions: FocusGroupSessionSchema[] = session ? [session] : [];

  // const sessionDuration = 2 * 60 * 60 * 1000;
  const sessionDuration = session ? session?.duration : 0;

  const { submitFocusGroupSession, pastSessionResponse, isSubmitting } = useFocusGroupSession(user?.uid || '', sessionId);

  const isManualLive = false
  // const orgName = session?.orgName;
  // const OrgLogo = session?.orgLogo;
  const sessionDate = session?.sessionDate;
  const now = moment();

  const sessionTypeName = (session && session?.sessionType) ? capitalizeWords(session?.sessionType?.split('_').join(' ')) : 'Focus Group'

  useEffect(() => {
      // Ensure document title is always overridden with a valid value, replacing any previous title
      const sessionNumber = session?.sessionNumber ? ` ${session.sessionNumber}` : '';
      document.title = `${session?.orgName || ''} ${sessionTypeName || ''} Session ${sessionNumber || ''}`;
  }, [session?.orgName, sessionTypeName, session?.sessionNumber])

  if (isSubmitting) {
    return (
      <FocusGroupSessionSkeleton />
    );
  }

  if (pastSessionResponse) {
    return (
      <div className="min-h-screen bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 py-12">
          <div className="mb-6">
            <button
              onClick={() => navigate('/focus-group')}
              className="flex items-center space-x-2 px-4 py-2 bg-white hover:bg-gray-50 text-gray-700 hover:text-gray-900 rounded-lg border border-gray-200 transition-all duration-200 group shadow-sm hover:shadow"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-500 group-hover:text-primaryDark-0 transition-colors duration-200" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
              </svg>
              <span className="font-medium">Back to All Sessions</span>
            </button>
          </div>

          <div className="bg-white rounded-xl shadow-lg p-8 border border-gray-100">
            <div className="text-center mb-8">
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-purple-100 mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-purple-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h2 className="text-2xl font-bold text-gray-900 mb-2">{sessionTypeName} Completed</h2>
              <p className="text-gray-600 max-w-md mx-auto mb-8">
                You have successfully submitted your responses for this {sessionTypeName.toLowerCase()}. Thank you for your participation!
              </p>
            </div>

            <div className="space-y-4">
              <div className="p-6 bg-purple-50 rounded-lg border border-purple-100">
                <div className="flex items-start space-x-4">
                  <div className="p-2 bg-purple-100 rounded-lg">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-purple-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">{sessionTypeName} Details</h3>
                    <div className="space-y-3">
                      <div className="flex items-center text-purple-700">
                        <span className="font-medium">Date:</span>
                        <span className="ml-2">{sessionDate?.format('dddd, MMMM D, YYYY')}</span>
                      </div>
                      <div className="flex items-center text-purple-700">
                        <span className="font-medium">Time:</span>
                        <span className="ml-2">{sessionDate?.format('h:mm A')}</span>
                      </div>
                      <div className="flex items-center text-purple-700">
                        <span className="font-medium">Duration:</span>
                        <span className="ml-2">{formatDuration(session?.duration)}</span>
                      </div>
                    </div>
                  </div>

                  {
                      session?.resource_id && session?.resource_type && (
                          <button 
                              onClick={() => navigate(`/${session?.resource_type}/${session?.resource_id}`)}
                              className="bg-primaryDark-0 hover:bg-primaryDark-100 text-white text-sm px-6 py-3.5 rounded-lg font-semibold shadow-sm hover:shadow-md transition-all duration-200 my-auto"
                          >
                              View {capitalizeString(session?.resource_type)}
                          </button>
                      )
                  }
                </div>
              </div>

              <button
                onClick={() => navigate('/focus-group')}
                className="w-full bg-primaryDark-0 hover:bg-primaryDark-100 text-white px-6 py-3.5 rounded-lg font-semibold shadow-sm hover:shadow-md transition-all duration-200"
              >
                View Other Sessions
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  } else if (session && !isManualLive && !(now.isSameOrAfter(sessionDate) && now.isSameOrBefore(moment(sessionDate).add(sessionDuration, 'minutes')))) {
    return (
      <div className="min-h-screen bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 py-12">
          <div className="mb-6">
            <button
              onClick={() => navigate('/focus-group')}
              className="flex items-center space-x-2 px-4 py-2 bg-white hover:bg-gray-50 text-gray-700 hover:text-gray-900 rounded-lg border border-gray-200 transition-all duration-200 group shadow-sm hover:shadow"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-500 group-hover:text-primaryDark-0 transition-colors duration-200" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
              </svg>
              <span className="font-medium">Back to All Sessions</span>
            </button>
          </div>

          <div className="bg-white rounded-xl shadow-lg p-8 border border-gray-100">
            <div className="text-center mb-8">
              <div className={`inline-flex items-center justify-center w-16 h-16 rounded-full ${now.isAfter(sessionDate) ? 'bg-gray-100' : 'bg-blue-100'} mb-4`}>
                <svg xmlns="http://www.w3.org/2000/svg" className={`h-8 w-8 ${now.isAfter(sessionDate) ? 'text-gray-600' : 'text-blue-600'}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h2 className="text-2xl font-bold text-gray-900 mb-2">
                {now.isAfter(sessionDate) ? 'Session Has Ended' : 'Session Not Started'}
              </h2>
              <p className="text-gray-600 max-w-md mx-auto mb-8">
                {now.isAfter(sessionDate) 
                  ? 'This session has already ended. Please check the schedule for upcoming sessions.'
                  : 'This session has not started yet. Please return at the scheduled time to join.'}
              </p>
            </div>

            <div className="space-y-4">
              <div className={`p-6 ${now.isAfter(sessionDate) ? 'bg-gray-50 border-gray-100' : 'bg-blue-50 border-blue-100'} rounded-lg border`}>
                <div className="flex items-start space-x-4">
                  <div className={`p-2 ${now.isAfter(sessionDate) ? 'bg-gray-100' : 'bg-blue-100'} rounded-lg`}>
                    <svg xmlns="http://www.w3.org/2000/svg" className={`h-6 w-6 ${now.isAfter(sessionDate) ? 'text-gray-600' : 'text-blue-600'}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                    </svg>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">Session Details</h3>
                    <div className="space-y-3">
                      <div className={`flex items-center ${now.isAfter(sessionDate) ? 'text-gray-700' : 'text-blue-700'}`}>
                        <span className="font-medium">Date:</span>
                        <span className="ml-2">{sessionDate?.format('dddd, MMMM D, YYYY')}</span>
                      </div>
                      <div className={`flex items-center ${now.isAfter(sessionDate) ? 'text-gray-700' : 'text-blue-700'}`}>
                        <span className="font-medium">Time:</span>
                        <span className="ml-2">{sessionDate?.format('h:mm A')}</span>
                      </div>
                      {now.isAfter(sessionDate) && (
                        <div className="flex items-center text-gray-700">
                          <span className="font-medium">Duration:</span>
                          <span className="ml-2">{session?.duration} minutes</span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <button
                onClick={() => navigate('/focus-group')}
                className="w-full bg-primaryDark-0 hover:bg-primaryDark-100 text-white px-6 py-3.5 rounded-lg font-semibold shadow-sm hover:shadow-md transition-all duration-200"
              >
                {now.isAfter(sessionDate) ? 'View Upcoming Sessions' : 'View All Sessions'}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
  
  
  if (!session) {
    return (
      <div className="min-h-screen bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 py-12">
          <div className="mb-6">
            <button
              onClick={() => navigate('/focus-group')}
              className="flex items-center space-x-2 px-4 py-2 bg-white hover:bg-gray-50 text-gray-700 hover:text-gray-900 rounded-lg border border-gray-200 transition-all duration-200 group shadow-sm hover:shadow"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-500 group-hover:text-primaryDark-0 transition-colors duration-200" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
              </svg>
              <span className="font-medium">Back to All Sessions</span>
            </button>
          </div>

          <div className="bg-white rounded-xl shadow-lg p-8 border border-gray-100">
            <div className="text-center mb-8">
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-red-100 mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                </svg>
              </div>
              <h2 className="text-2xl font-bold text-gray-900 mb-2">Session Not Found</h2>
              <p className="text-gray-600 max-w-md mx-auto mb-8">
                We couldn't find the session you're looking for. It may have been removed or the link might be incorrect.
              </p>
            </div>

            <div className="space-y-4">
              <div className="p-4 bg-red-50 rounded-lg border border-red-100">
                <div className="flex items-start space-x-3">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-red-500 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <div>
                    <p className="text-sm text-gray-600">
                      If you believe this is an error, please try:
                    </p>
                    <ul className="mt-2 space-y-1 text-sm text-gray-600 list-disc list-inside">
                      <li>Checking the session URL</li>
                      <li>Verifying if the session is still active</li>
                      <li>Contacting the session organizer</li>
                    </ul>
                  </div>
                </div>
              </div>

              <button
                onClick={() => navigate('/focus-group')}
                className="w-full bg-primaryDark-0 hover:bg-primaryDark-100 text-white px-6 py-3.5 rounded-lg font-semibold shadow-sm hover:shadow-md transition-all duration-200"
              >
                Return to Available Sessions
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
  
  // console.log(session)
  const handleResponse = (questionId: string, value: any) => {
    setResponses(prev => ({
      ...prev,
      [questionId]: value
    }));
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>, maxSelections: number) => {
    if (maxSelections === 1) {
      setOtherTexts(
        prev => ({ ...prev, [e.target.name]: e.target.value })
      )
    } else {
      setOtherTexts(
        prev => ({ ...prev, [e.target.name]: e.target.value })
      )
    }
  }


  const handleSubmit = async () => {
    // console.log('responses', responses)
    // console.log('otherTexts', otherTexts)
    const responsesWithOtherTexts = Object.entries(responses).reduce((acc, [key, value]) => {
      if (Array.isArray(value)) {
        // Handle array responses (multiple selections)
        acc[key] = value.map(item => 
          item === 'Other' && otherTexts[key] ? otherTexts[key] : item
        );
      } else if (value === 'Other' && otherTexts[key]) {
        // Handle single selection 'Other' response
        acc[key] = otherTexts[key];
      } else {
        // Keep other responses as is
        acc[key] = value;
      }
      return acc;
    }, {} as Record<string, any>);
    // console.log('responsesWithOtherTexts', responsesWithOtherTexts)

    const [hours, minutes, seconds] = elapsedTime.split(':').map(Number);
    const durationInMinutes = hours * 60 + minutes + seconds / 60;
    responsesWithOtherTexts['completion_duration'] = durationInMinutes
    responsesWithOtherTexts['community_id'] = session.community_id
    // console.log('responsesWithOtherTexts', responsesWithOtherTexts)
    const submitted = await submitFocusGroupSession(responsesWithOtherTexts as FocusGroupSessionResponseSchema)
    if (submitted) {
      toast.success(
        <span style={{ fontSize: '1rem' }}>
          Session response submitted successfully. Thank you for your participation!
        </span>,
        {
        duration: 5000,
        position: 'top-right',
      })
      navigate(`/focus-group/${sessionId}`)
    } else {
      toast.error(
        <span style={{ fontSize: '1rem' }}>
          Failed to submit session response. Please try again.
        </span>,
        {
          duration: 5000,
          position: 'top-right',
        }
      )
    }
  }

  const handleNext = () => {
    const section = session.sections[currentSection];
    if (currentQuestion < section.questions.length - 1) {
      setCurrentQuestion(prev => prev + 1);
    } else if (currentSection < session.sections.length - 1) {
      setCurrentSection(prev => prev + 1);
      setCurrentQuestion(0);
    } else if (currentSession < liveSessions.length - 1) {
      setCurrentSession(prev => prev + 1);
      setCurrentSection(0);
      setCurrentQuestion(0);
    }
  };

  const handlePrevious = () => {
    if (currentQuestion > 0) {
      setCurrentQuestion(prev => prev - 1);
    } else if (currentSection > 0) {
      setCurrentSection(prev => prev - 1);
      const prevSection = session.sections[currentSection - 1];
      setCurrentQuestion(prevSection.questions.length - 1);
    } else if (currentSession > 0) {
      setCurrentSession(prev => prev - 1);
      const prevSession = liveSessions[currentSession - 1] as FocusGroupSessionSchema;
      setCurrentSection(prevSession.sections.length - 1);
      const lastSection = prevSession.sections[prevSession.sections.length - 1];
      setCurrentQuestion(lastSection.questions.length - 1);
    }
  };

  const calculateProgress = () => {
    let totalQuestions = 0;
    let answeredQuestions = 0;

    liveSessions.forEach(session => {
      (session as FocusGroupSessionSchema).sections.forEach(section => {
        section.questions.forEach(question => {
          totalQuestions++;
          if (responses[question.id]) {
            answeredQuestions++;
          }
        });
      });
    });

    return (answeredQuestions / totalQuestions) * 100;
  };

  const renderQuestion = (question: Question) => {
    switch (question.type) {
      case 'checkbox':
        return (
          <div className="space-y-4">
            {question.options?.map((option, index) => (
              <label key={index} className="flex items-center space-x-3 p-3 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer">
                <input
                  type={question.maxSelections === 1 ? "radio" : "checkbox"}
                  name={question.id}
                  className={`${question.maxSelections === 1 ? 'form-radio rounded-full' : 'form-checkbox rounded-md'} h-5 w-5 text-primaryDark-0 border-gray-300 rounded focus:ring-primaryDark-0`}
                  checked={question.maxSelections === 1 
                    ? responses[question.id] === option 
                    : responses[question.id]?.includes(option) || false}
                  onChange={(e) => {
                    if (question.maxSelections === 1) {
                      handleResponse(question.id, option);
                    } else {
                      const currentResponses = responses[question.id] || [];
                      let newResponses;
                      
                      if (e.target.checked) {
                        if (question.maxSelections && currentResponses.length >= question.maxSelections) {
                          return;
                        }
                        newResponses = [...currentResponses, option];
                      } else {
                        newResponses = currentResponses.filter((r: string) => r !== option);
                      }
                      
                      handleResponse(question.id, newResponses);
                    }
                  }}
                />
                <span className="text-gray-700">{option}</span>
                {
                  option === 'Other' && (
                    question.maxSelections === 1 
                    ? responses[question.id] === option 
                    : responses[question.id]?.includes(option) || false
                  ) && (
                    <input
                      type="text"
                      className="flex-1 p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-primaryDark-0 focus:border-transparent w-auto"
                      placeholder="Please specify..."
                      name={question.id}
                      value={otherTexts[question.id] || ''}
                      onChange={e => handleInputChange(e, question.maxSelections || 1)}
                    />
                  )
                }
              </label>
            ))}
          </div>
        );
      case 'rating':
        return (
          <div className="space-y-6">
            {question.options?.map((option, index) => (
              <div key={index} className="flex items-center justify-between p-3 rounded-lg hover:bg-gray-50 transition-colors">
                <span className="text-gray-700">{option}</span>
                <div className="flex space-x-2">
                  {[1, 2, 3, 4, 5].map((rating) => (
                    <button
                      key={rating}
                      className={`w-8 h-8 rounded-full flex items-center justify-center transition-colors ${
                        responses[question.id]?.[option] === rating
                          ? 'bg-primaryDark-0 text-white border-primaryDark-0'
                          : 'bg-gray-100 text-gray-600 hover:bg-gray-200 border-gray-300'
                      }`}
                      onClick={() => handleResponse(question.id, { ...responses[question.id], [option]: rating })}
                    >
                      {rating}
                    </button>
                  ))}
                </div>
              </div>
            ))}
          </div>
        );
      case 'open':
        return (
          <textarea
            className="w-full p-4 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primaryDark-0 focus:border-transparent transition-colors"
            rows={4}
            value={responses[question.id] || ''}
            onChange={(e) => handleResponse(question.id, e.target.value)}
            placeholder="Type your response here..."
          />
        );
      default:
        return null;
    }
  };

  // const currentSessionData = MOCK_FOCUS_GROUPS[currentSession] as FocusGroupSchema;
  const currentSectionData = session.sections[currentSection];
  const currentQuestionData = currentSectionData.questions[currentQuestion];

  // const orgName = 'Dreamers';
  // const OrgLogo = `https://dreamingoutloud.org/wp-content/uploads/2024/10/Dreaming-Out-Loud-Home-Logo-.webp`

  const isFinalSession = currentSession === liveSessions.length - 1 && currentSection === session.sections.length - 1  && currentQuestion === currentSectionData.questions.length - 1 
  // const sessionTypeName = session.sessionType ? capitalizeWords(session.sessionType.split('_').join(' ')) : 'Focus Group'
  return (
    <div className="min-h-screen bg-gray-50 mt-[50px] sm:mt-0">
      {/* Progress Bar */}
      <div className="fixed top-0 left-0 w-full h-1 bg-gray-200 z-50">
        <div
          className="h-full bg-primaryDark-0 transition-all duration-300"
          style={{ width: `${calculateProgress()}%` }}
        />
      </div>

      {/* Header */}
      <header className="bg-white shadow-sm">
        <div className="max-w-6xl mx-auto px-4 py-4 sm:py-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4 sm:space-x-6">
              <button
                onClick={() => navigate(`/focus-group/${session.id}`)}
                className="flex items-center space-x-2 px-3 py-1.5 sm:px-4 sm:py-2 bg-white hover:bg-gray-50 text-gray-700 hover:text-gray-900 rounded-lg border border-gray-200 transition-all duration-200 group shadow-sm hover:shadow"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 sm:h-5 sm:w-5 text-gray-500 group-hover:text-primaryDark-0 transition-colors duration-200" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                </svg>
                <span className="text-sm sm:text-base font-medium">Exit Session</span>
              </button>
              <LiveSessionIndicator elapsedTime={elapsedTime} setElapsedTime={setElapsedTime} startTime={sessionStartTime} duration={session?.duration} />
            </div>
          </div>
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mt-4 space-y-3 sm:space-y-0">
            <div className="flex items-center space-x-3 sm:space-x-4">
              <img src={session?.orgLogo} alt={session?.orgName} className="w-12 h-10 sm:w-16 sm:h-14 object-contain" />
              <div>
                <h1 className="text-xl sm:text-2xl font-bold text-gray-900">{session?.orgName} {sessionTypeName}</h1>
                <p className="text-sm sm:text-base text-gray-600">{sessionTypeName} {session?.sessionNumber}: {session?.title}</p>
              </div>
            </div>
            <div className="text-right">
              <p className="text-xs sm:text-sm text-gray-500">Progress</p>
              <p className="text-base sm:text-lg font-semibold text-primaryDark-0">{Math.round(calculateProgress())}%</p>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-6xl mx-auto px-4 py-6 sm:py-8">
        <div className="flex flex-col lg:flex-row gap-4 sm:gap-6">
          {/* Session Map - Hidden on mobile, shown on desktop */}
          <div className="hidden lg:block">
            <SessionMap 
              currentSession={currentSession}
              currentSection={currentSection}
              sessions={liveSessions}
              isFinalSection={isFinalSession}
            />
          </div>

          {/* Content Area */}
          <div className="flex-1">
            <div className="bg-white rounded-lg shadow-sm p-4 sm:p-6 mb-4 sm:mb-6">
              <div className="flex items-center space-x-3 mb-3 sm:mb-4">
                <currentSectionData.icon className="text-lg sm:text-xl text-primaryDark-0" />
                <h2 className="text-lg sm:text-xl font-semibold text-gray-900">{currentSectionData.title}</h2>
              </div>
              
              <div className="space-y-4 sm:space-y-6">
                <div>
                  <h3 className="text-base sm:text-lg font-medium text-gray-900 mb-2">{currentQuestionData.title}</h3>
                  <p className="text-sm sm:text-base text-gray-600 mb-3 sm:mb-4">{currentQuestionData.text}</p>
                  {renderQuestion(currentQuestionData)}
                </div>
              </div>
            </div>

            {/* Navigation */}
            <div className="flex flex-col sm:flex-row justify-between items-center bg-white rounded-xl shadow-lg p-4 sm:p-6 border border-gray-100 space-y-3 sm:space-y-0">
              <button
                onClick={handlePrevious}
                disabled={currentSession === 0 && currentSection === 0 && currentQuestion === 0}
                className="w-full sm:w-auto flex items-center justify-center space-x-3 px-4 sm:px-6 py-2 sm:py-3 bg-white text-gray-700 rounded-lg hover:bg-gray-50 transition-all duration-200 disabled:opacity-40 disabled:cursor-not-allowed border border-gray-200 font-medium"
              >
                <ArrowBack className="text-lg sm:text-xl" />
                <span>Previous</span>
              </button>
              
              <div className="text-xs sm:text-sm font-medium text-gray-500">
                Question {currentQuestion + 1} of {currentSectionData.questions.length}
              </div>
              
              <button
                onClick={() => isFinalSession ? handleSubmit() : handleNext()}
                disabled={!isFinalSession && 
                         currentSection === session.sections.length - 1 && 
                         currentQuestion === currentSectionData.questions.length - 1}
                className="w-full sm:w-auto flex items-center justify-center space-x-3 px-4 sm:px-6 py-2 sm:py-3 bg-primaryDark-0 text-white rounded-lg hover:bg-primaryDark-100 transition-all duration-200 disabled:opacity-40 disabled:cursor-not-allowed shadow-sm hover:shadow-md"
              >
                <span className="font-medium">
                  {isFinalSession ? 'Submit' : 'Next'}
                </span>
                <ArrowForward className="text-lg sm:text-xl" />
              </button>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

export default FocusGroupSession;
